import React, {
  forwardRef,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";

import {
  GridData,
  GridDataOptions,
  GridProps,
  Pager,
  Sorter,
} from "../../../../../component/DataList/schema";
import {
  getDataSource,
  getDictionaryMapper,
  getGridData,
} from "../../../../../component/DataList/util";
import { List } from "antd-mobile";

const { Item } = List;
const Brief = Item.Brief;

const HistoryDataList = forwardRef(
  (
    {
      url,
      pagination,
      descriptions,
      expressions,
      sorter,
      onClickRow,
      pageSize = 10,
      render,
    }: GridProps & { render?: (item: unknown, index: number) => void },
    ref: any
  ) => {
    const searchFormRef = useRef<{ [key: string]: string }>({});
    const [formattedData, setFormattedData] = useState<any[]>([]);
    const [pageIndex, setPageIndex] = useState<number>(1);
    /**
     * 仅查询数据
     * @param pager
     * @param currentSorter
     */
    const getData = useCallback(
      async function getData(
        pager?: Pager,
        currentSorter?: Sorter
      ): Promise<GridData> {
        const options: GridDataOptions = {
          url,
          dictionaryMapper: getDictionaryMapper(descriptions),
          pagination: pagination !== false,
          pager: pager,
          sorter: currentSorter && currentSorter.order ? currentSorter : sorter,
          searchForm: searchFormRef.current,
          fuzzySearch: "",
          innerDescriptions: descriptions,
        };
        return await getGridData(options);
      },
      [descriptions, expressions, pagination, sorter, url]
    );

    /**
     * 加载数据
     * @param pager
     * @param currentSorter
     */
    const loadData = useCallback(
      async function loadData(pager?: Pager, currentSorter?: Sorter) {
        const gridData = await getData(pager, currentSorter);
        const gridDataCopy = {
          ...gridData,
          data: gridData?.data[0]?.completions,
        };
        gridDataCopy &&
          gridDataCopy.data &&
          gridDataCopy.data.length > 0 &&
          gridDataCopy.data.forEach((item: any, index: any) => {
            if (!item.uuid) item.uuid = (+new Date()).toString() + index;
          });
        if (gridDataCopy) {
          setFormattedData((prevState) => {
            return getDataSource(gridDataCopy, descriptions);
          });
        }
      },
      [descriptions, getData]
    );

    useEffect(() => {
      loadData({ pageIndex, pageSize: pageSize }).then();
    }, [loadData, pageIndex, pageSize]);

    return (
      <>
        <List>
          {formattedData.map((item, index) =>
            render ? (
              render(item, index)
            ) : (
              <Item
                wrap
                align="top"
                multipleLine
                onClick={() => {
                  if (onClickRow) {
                    onClickRow(item);
                  } else {
                    return;
                  }
                }}
              >
                {item[descriptions[0].fieldName!]}
                <Brief>
                  {descriptions
                    .slice(1, descriptions.length)
                    .filter((desc) => item[desc.fieldName!])
                    .map((desc) => (
                      <div className={"whitespace-normal"}>{`${
                        desc.fieldShowName
                      }: ${item[desc.fieldName!]}`}</div>
                    ))}
                </Brief>
              </Item>
            )
          )}
        </List>
      </>
    );
  }
);

export default HistoryDataList;
